import { IS_PLAYWRIGHT_TEST } from "@helper/getEnvVariables";
import { getCookieByName, isClientSide } from "@helper/utils";
import { useCallback, useEffect } from "react";
import TagManager from "react-gtm-module";

export function useNeuronPageViewPush({
  autoFire = true,
}: { autoFire?: boolean } = {}) {
  const neuronPageView = useCallback(() => {
    if (!isClientSide || IS_PLAYWRIGHT_TEST === "true") return;
    if (typeof window._data === "undefined") return;

    const permutive_id = window.localStorage.getItem("permutive-id") || "";
    const neuron_dataLayer = window._data;

    const visitorcat = getCookieByName("visitorcat") as unknown;
    const mysphw = getCookieByName("mysphw");
    if (visitorcat !== undefined && mysphw !== undefined) {
      neuron_dataLayer.visitorcat = visitorcat as 1 | 2;
      neuron_dataLayer.at = mysphw;
    }

    const storedKeywords = localStorage.getItem("mybh-keywords");

    if (storedKeywords) {
      try {
        const parsed = JSON.parse(storedKeywords) as {
          state?: { tags?: Array<{ name?: string }> };
        };
        const tags = Array.isArray(parsed.state?.tags) ? parsed.state.tags : [];
        neuron_dataLayer.user_keyword =
          tags
            .filter(
              (tag): tag is { name: string } => typeof tag.name === "string",
            )
            .map((tag) => tag.name.toLowerCase())
            .join("|") || "";
      } catch {
        neuron_dataLayer.user_keyword = "";
      }
    }

    const pageViewData = {
      event: "pageview",
      at: neuron_dataLayer.at,
      permutive_id: permutive_id,
      visitorcat: neuron_dataLayer.visitorcat,
      articleid: neuron_dataLayer.articleid,
      cue_articleid: neuron_dataLayer.cue_articleid,
      author: neuron_dataLayer.author || "",
      chapter1: neuron_dataLayer.chapter1,
      chapter2: neuron_dataLayer.chapter2,
      chapter3: "",
      contentcat: neuron_dataLayer.contentcat,
      contenttype: neuron_dataLayer.contenttype,
      keyword: neuron_dataLayer.keyword,
      level2: neuron_dataLayer.level2,
      pubdate: neuron_dataLayer.pubdate,
      content_publication_date_utc:
        neuron_dataLayer.content_publication_date_utc,
      content_update_date_utc: neuron_dataLayer.content_update_date_utc,
      titleGa: neuron_dataLayer.title,
      url: window.location.href,
      user_keyword: neuron_dataLayer.user_keyword,
    };

    TagManager.dataLayer({
      dataLayer: pageViewData,
    });
  }, []);

  useEffect(() => {
    if (!autoFire || !isClientSide || IS_PLAYWRIGHT_TEST === "true") return;

    if (typeof window._data !== "undefined") {
      neuronPageView();
      return;
    }

    const interval = setInterval(() => {
      if (typeof window._data !== "undefined") {
        neuronPageView();
        clearInterval(interval);
      }
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, [autoFire, neuronPageView]);

  return neuronPageView;
}
